/**
 * Route for `agency-dashboard-aggregating-all-client-performance`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AgencyDashboardAggregatingAllClientPerformancePage } from "../features/agency-dashboard-aggregating-all-client-performance/AgencyDashboardAggregatingAllClientPerformancePage";

export const agencyDashboardAggregatingAllClientPerformanceRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/agency-dashboard-aggregating-all-client-performance",
	component: AgencyDashboardAggregatingAllClientPerformancePage,
});

export default agencyDashboardAggregatingAllClientPerformanceRoute;
